import request from '../../utils/request';
import {paramSecret} from "../../utils/commonSecret";

// 账号密码登录
export async function LoginForPcByPwd(params) {
    return request('/api/v1/business-server/member/loginForPcByPwd', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}